/**
 * Сайт живёт в двух зонах на одном домене: клуб (корень) и магазин (/shop).
 * Зона определяется по адресу и решает, какое меню показать в шапке.
 */

export type Zone = 'club' | 'shop'

const SHOP_PREFIXES = ['/shop', '/products', '/cart', '/checkout', '/orders', '/search']

export const zoneOf = (pathname: string): Zone =>
  SHOP_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`) || pathname.startsWith(`${p}?`)) ? 'shop' : 'club'
